import { render, staticRenderFns } from "./PrivateInstallments.vue?vue&type=template&id=885dbd24&"
import script from "./PrivateInstallments.vue?vue&type=script&lang=js&"
export * from "./PrivateInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports